// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2--q7","upload":"Small_upload__FrYyY","imageWrap":"Small_imageWrap__2sk4o","removeBtn":"Small_removeBtn__2GlGs"};